export const IsNullOrUndefined = (value: unknown): value is null | undefined => value === null || value === undefined;
